import { useRef, useLayoutEffect } from 'react';

/**
 * A ref holding the latest committed `value` — for callbacks that must keep one identity
 * (so memoized children don't re-render) yet read current data when they run. Updated
 * after commit, not during render, so a render React throws away never leaks into it.
 */
export function useLatest(value) {
  const ref = useRef(value);
  useLayoutEffect(() => { ref.current = value; });
  return ref;
}
